import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// components
import {
  Box,
  MainHolder,
  StyledText,
  DynamicButton,
  Button,
} from "../../../../components/common";

// hooks
import { useTheme, useSpinTheWheel } from "../../../../hooks";
import { useSpinTheWheelHome } from "../hooks";

// theme

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const DataRedemption = () => {
  const history = useHistory();

  const { themeContext, theme } = useTheme();
  const { itemWon } = useSpinTheWheel();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const { setSubmissionResponseData } = useSpinTheWheel();
  return (
    <MainHolder
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
      }}
    >
      <div>
        <StyledText style={{ textAlign: "center", fontSize: 25 }}>
          You won {itemWon.option}
        </StyledText>
        <Box
          style={{
            backgroundColor: "#F2F2F2",
            marginTop: "5%",
            marginInline: "10%",
            borderRadius: 5,
            padding: "20px 30px",
          }}
        >
          <PrizeCard
            img={`${SERVER_URL}/assets/images/airtime.jpg`}
            prize={itemWon.option}
          />
        </Box>
      </div>
      <div
        style={{
          width: "100%",
          height: 1,
          backgroundColor: "#F2F2F2",
          margin: "40px 15px",
        }}
      />
      <StyledText
        style={{
          margin: "0px 15px",
          padding: 0,
          fontFamily: "MTNRegular",
          textAlign: "center",
        }}
      >
        Your number will be credited with 2.6GB worth of data in the next 24
        hours
      </StyledText>
      <div style={{ margin: 20 }}>
        <DynamicButton
          label={"Got it"}
          color={"#E31C79"}
          width={"100%"}
          onClick={() => {
            setSubmissionResponseData(null);
            history.push(`/spin_the_wheel`)
          }}
        />
      </div>
    </MainHolder>
  );
};

export default DataRedemption;

const PrizeCard = ({ img, prize, description }) => {
  const { themeContext } = useTheme();
  const { activeTheme } = themeContext;

  return (
    <Box
      themeAware={false}
      style={{
        borderRadius: 20,
        backgroundColor: "white",
        shadowColor: activeTheme === "midnight" ? "black" : "#242424",
        shadowOffset: {
          width: 0,
          height: 0,
        },
        shadowOpacity: activeTheme === "midnight" ? 1 : 0.23,
        shadowRadius: 1.62,
        elevation: 4,
        justifyContent: "space-between",
      }}
    >
      <>
        <FastImage
          style={{
            height: 190,
            width: "100%",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
          }}
          src={img}
        />
        <FastImage
          style={{
            height: "100%",
            width: "100%",
            marginTop: -38,
          }}
          src={`${SERVER_URL}/assets/images/BigCardCurve.png`}
        />
      </>
      <Box
        themeAware={false}
        style={{ alignSelf: "center", backgroundColor: "transparent" }}
      >
        <StyledText align={"center"} margin={0} fontFamily={"medium"} size={26}>
          {description}
        </StyledText>
        <StyledText
          fontFamily={"medium"}
          size={24}
          align={"center"}
          style={{
            textAlign: "center",
            margin: 0,
            paddingBottom: 10,
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          {prize}
        </StyledText>
      </Box>
    </Box>
  );
};

const FastImage = styled.img``;
